var init_scripts = [];
var resize_scripts = [];
var resizeTimer;
var debug = location.href.includes('debug=1');

debug && console.log('shared v1');

window.addEventListener('resize', function(){
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(handleResize, 250);
});

window.addEventListener('load', function(){
	for (var i = 0; i != init_scripts.length; ++i){
		if (typeof init_scripts[i] == 'function'){
			init_scripts[i]();
		}
	}
});

function handleResize(){
	for (var i = 0; i != resize_scripts.length; ++i){
		if (typeof resize_scripts[i] == 'function'){
			resize_scripts[i]();
		}
	}
}